import { Construction } from 'lucide-react';
import { SectionHeader, EmptyState } from '@pixlide/ui';

/**
 * Écran non encore implémenté.
 *
 * Choix assumé pour un squelette : la route, la navigation et le contrôle d'accès sont en
 * place et testés ; seul le contenu métier reste à écrire. Un lien qui mène à une page
 * explicite vaut mieux qu'un lien mort ou qu'une entrée de menu absente, qui masquerait le
 * périmètre restant à couvrir.
 */
export function PlaceholderPage({ title, description }: { title: string; description: string }) {
  return (
    <div className="mx-auto flex max-w-4xl flex-col gap-6">
      <SectionHeader title={title} />

      <EmptyState
        icon={<Construction className="size-10" strokeWidth={1.25} />}
        title="Écran en cours de développement"
        description={description}
      />
    </div>
  );
}
